// Taskbar navigation data

export interface TaskbarItem {
  id: string
  label: string
  symbol: string
}

export const TASKBAR_ITEMS: TaskbarItem[] = [
  { id: 'work', label: 'WORK', symbol: '◈' },
  { id: 'thoughts', label: 'THOUGHTS', symbol: '◉' },
  { id: 'photography', label: 'PHOTOS', symbol: '◐' },
]
